import React, { Fragment, useContext, useEffect, useState } from "react";
import { api, schemaVersion } from "../../logic/api";
import { SessionContext } from "../../utility/useSession";
import packageJson from '../../../package.json';

const VersionInfo = () => {
    const session = useContext(SessionContext);
    const [params] = useState({});
    const versionRequest = api.hooks.auth.version();

    useEffect(() => {
        versionRequest.send(session.current.context, params);
    }, [params]);

    if (versionRequest.data != null) {
        const mismatched = schemaVersion.toString() != versionRequest.data.schemaVersion.toString();

        return <Fragment>
            <div style={mismatched ? { color: "red" } : {}}>
                Client: <b>{packageJson.version}.{schemaVersion}</b>, API: <b>{versionRequest.data.serverVersion}.{versionRequest.data.schemaVersion}</b>
            </div>
        </Fragment>
    }
    return <Fragment>Client: <b>{schemaVersion}</b></Fragment>
}

export default VersionInfo;